import React from "react";
import { Check, ArrowRight } from "lucide-react";
import Images from "../../../../../utils/Images";

/**
 * Step One: Type Selection Component
 * Allows user to select between Conference or Trade Mission
 */
const StepOneTypeSelection = ({ selectedType, onSelect, onNext }) => {
  const types = [
    {
      id: "conference",
      title: "Conference",
      description: "Host professional gatherings such as seminars, workshops, conventions, and corporate events.",
      color: "from-orange-500 to-orange-600",
      bgColor: "bg-orange-50",
      textColor: "text-orange-700",
      borderColor: "border-orange-200",
      image: Images.conference,
    },
    {
      id: "trade_mission",
      title: "Trade Mission",
      description: "Facilitate international business connections and market expansion opportunities.",
      color: "from-orange-500 to-orange-600",
      bgColor: "bg-orange-50",
      textColor: "text-orange-700",
      borderColor: "border-orange-200",
      image: Images.trade_mission,
    },
  ];

  const handleSelect = (type) => {
    onSelect(type);
  };

  const handleNext = () => {
    if (selectedType) {
      onNext();
    }
  };

  return (
    <div className="space-y-6">
      <div className="text-center">
        <h2 className="mb-2 text-2xl font-bold text-gray-900">Select Type</h2>
        <p className="text-gray-600">
          Choose whether you want to create a Conference or Trade Mission
        </p>
      </div>

      <div className="grid grid-cols-1 gap-6 md:grid-cols-2">
        {types.map((type) => {
          const isSelected = selectedType === type.id;

          return (
            <button
              key={type.id}
              onClick={() => handleSelect(type.id)}
              className={`relative p-6 text-left border-2 rounded-2xl transition-all duration-200 hover:shadow-lg ${
                isSelected
                  ? `${type.borderColor} ${type.bgColor} shadow-md`
                  : "border-gray-200 bg-white hover:border-gray-300"
              }`}
            >
              {isSelected && (
                <div className="absolute top-4 right-4">
                  <div className={`p-1.5 ${type.bgColor} rounded-full`}>
                    <Check className={`w-5 h-5 ${type.textColor}`} />
                  </div>
                </div>
              )}

              <div className="flex flex-col items-center justify-between space-y-4 space-x-4">
                <img src={type.image} alt={type.title} className="w-48" />
                <div className="flex-1 min-w-0">
                  <h3
                    className={`mb-1 text-2xl font-bold text-center ${
                      isSelected ? type.textColor : "text-gray-900"
                    }`}
                  >
                    {type.title}
                  </h3>
                  <p className="text-lg text-gray-600 text-center">{type.description}</p>
                </div>
              </div>
            </button>
          );
        })}
      </div>

      {selectedType && (
        <div className="flex justify-end pt-4">
          <button
            onClick={handleNext}
            className="flex items-center px-6 py-3 font-semibold text-white bg-gradient-to-r from-orange-600 to-orange-700 rounded-xl shadow-md transition-all hover:shadow-lg hover:from-orange-700 hover:to-orange-800"
          >
            Continue
            <ArrowRight className="ml-2 w-5 h-5" />
          </button>
        </div>
      )}
    </div>
  );
};

export default StepOneTypeSelection;
